import * as React from "react";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import VisibleIcon from "@material-ui/icons/Visibility";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import LabelType from "../../types/Label";
import { Typography } from "@material-ui/core";

const styles = (theme: Theme) =>
  createStyles({
    labels: {
      padding: `0 ${theme.spacing.unit * 2}px`,
    },
    labelsModern: {
      padding: "0 16px",
    },
    padded: {
      padding: 5,
    },
  });

interface LabelsWithNumType extends LabelType {
  occurences?: number;
}

interface PropTypes {
  labels: LabelsWithNumType[];
  selected: number | null;
  classes: any;
  onClick: any;
  onVisibilityClick?: any;
  hideVisibilityIcon: boolean;
  variant?: "default" | "segmentation2";
}

const Labels = (props: PropTypes) => {
  const {
    labels,
    selected,
    classes,
    onClick,
    onVisibilityClick,
    hideVisibilityIcon,
    variant = "default",
  } = props;

  const handleChangeVisibility = (e: any, index: Number) => {
    e.preventDefault();
    e.stopPropagation();
    onVisibilityClick(index);
  };

  if (variant === "segmentation2") {
    return (
      <Grid
        container
        spacing={8}
        className={classes.labelsModern}
      >
        {labels.map((c: any, index: number) => {
          const isSelected = index === selected;
          const labelColor = c.color || "#ccc";
          return (
            <Grid item xs={6} key={index}>
              <Grid container>
                <Grid item xs={12}>
                  <Paper
                    style={{
                      backgroundColor: lighten(
                        labelColor,
                        isSelected ? 0.6 : 0.98
                      ),
                      border: `2px solid ${lighten(labelColor, isSelected ? 0 : 0.5)}`,
                      padding: "8px",
                      borderRadius: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() => onClick(index)}
                  >
                    <Grid container alignItems="center">
                      <Grid item xs={hideVisibilityIcon ? 12 : 10}>
                        <Typography>{c.legend}</Typography>
                      </Grid>
                      {!hideVisibilityIcon && (
                        <Grid item xs={2} style={{ textAlign: "right" }}>
                          <Typography>{c.occurences ?? 0}</Typography>
                        </Grid>
                      )}
                    </Grid>
                  </Paper>
                </Grid>
                {!hideVisibilityIcon && (
                  <Grid
                    item
                    container
                    xs={12}
                    justify="flex-end"
                    style={{ marginBottom: 8, height: 40, padding: "4px 2px" }}
                  >
                    <IconButton
                      onClick={(e: any) => handleChangeVisibility(e, index)}
                      title={`${c.visible ? "Cacher" : "Afficher"} les labellisations`}
                      style={{ padding: 4 }}
                    >
                      <VisibleIcon
                        style={{
                          color: c.visible ? labelColor : "silver",
                        }}
                      />
                    </IconButton>
                  </Grid>
                )}
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    );
  }

  return (
    <Grid
      container
      direction="row"
      spacing={8}
      justify="space-between"
      alignItems="center"
      className={classes.labels}
    >
      {labels.map((c: any, index: number) => {
        const color = lighten(c.color, index === selected ? 0 : 0.5);
        return (
          <Grid
            item
            key={index}
            xs={6}
            className={classes.padded}
            onClick={() => onClick(index)}
          >
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
              style={{
                border: `solid 3px ${color}`,
                borderLeft: `solid ${
                  index === selected ? "10px" : "3px"
                } ${color}`,
                borderRadius: "3px"
              }}
            >
              <Grid
                item
                xs={
                  hideVisibilityIcon
                    ? 11
                    : typeof c.occurences !== "undefined"
                    ? 8
                    : 9
                }
                style={{
                  paddingLeft: index === selected ? 5 : 9,
                  fontSize: hideVisibilityIcon ? 14 : 16,
                  padding: "0 5px"
                }}
              >
                {c.legend}
              </Grid>
              <Grid
                item
                xs={
                  hideVisibilityIcon
                    ? 1
                    : typeof c.occurences !== "undefined"
                    ? 4
                    : 3
                }
              >
                <IconButton
                  key={c.legend}
                  onClick={(e: any) => handleChangeVisibility(e, index)}
                  disabled={hideVisibilityIcon}
                  title={`${c.visible ? "Cacher" : "Afficher"} les${
                    c.occurences ? ` ${c.occurences}` : ""
                  } labellisations`}
                >
                  <VisibleIcon
                    style={{
                      color: c.visible ? color : "silver",
                      visibility: hideVisibilityIcon ? "hidden" : "visible"
                    }}
                  />
                  {typeof c.occurences !== "undefined" ? (
                    <Typography
                      style={{
                        fontSize: "0.5em",
                        fontWeight: 500,
                        color: c.visible ? color : "silver",
                        paddingBottom: 1,
                        paddingLeft: 2
                      }}
                    >
                      {c.occurences}
                    </Typography>
                  ) : null}
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};

Labels.defaultProps = {
  hideVisibilityIcon: false
};

export default withStyles(styles)(Labels);
